<p-autoComplete
  #autoComplete
  [appendTo]="'body'"
  [suggestions]="smartList.items()"
  [optionLabel]="textField()"
  [minLength]="minChars()"
  [delay]="debounceMs()"
  [placeholder]="placeholder()"
  [showClear]="showClear()"
  [dropdown]="showDropdown()"
  [completeOnFocus]="completeOnFocus()"
  [forceSelection]="forceSelection()"
  [showEmptyMessage]="true"
  [emptyMessage]="'No results found'"
  [fluid]="true"
  [disabled]="disabled()"
  [autoHighlight]="true"
  [(ngModel)]="selectedItem"
  (completeMethod)="onSearch($event)"
  (onSelect)="onItemSelected($event)"
  (onClear)="onItemCleared()"
  (onDropdownClick)="onDropdownClicked($event)"
  (onShow)="onPanelShow()"
  (onHide)="onPanelHide()"
></p-autoComplete>

@if (smartList.isLoading()) {
  <div class="cyflare-autocomplete-loading">
    <i class="pi pi-spinner pi-spin"></i>
  </div>
}
